export default __webpack_public_path__ + "6e9794bcedeecf5a8f8f41338a2a7345.jpg";